<template>
  <div>
    <el-autocomplete
      class="inline-input"
      v-model="curVal"
      :fetch-suggestions="querySearch"
      :placeholder="placeholder"
      @select="handleSelectField"
    ></el-autocomplete>
  </div>
  
</template>

<script>
  export default {
    props: {
      value: { // 当前输入框的内容
        type: String,
        default() {
          return ''
        }
      },
      placeholder: {  // 提示语
        type: String,
        default() {
          return ''
        }
      },
      listIndex: {  // 如果组件在列表中用到，需要传对应的列表项索引
        type: Number,
        default() {
          return 0
        }
      },
      inputSource: { // 下拉数据源
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        curVal: ''
      }
    },
    created() {
      this.curVal = this.value
    },
    methods: {
      querySearch(queryString, cb) {
        var inputSource = this.inputSource
        var results = queryString ? inputSource.filter(this.createFilter(queryString)) : inputSource
        // 调用 callback 返回建议列表的数据
        cb(results)
      },
      createFilter(queryString) {
        return (inputSource) => {
          return (inputSource.value.indexOf(queryString.toLowerCase()) > -1)
        }
      },
      handleSelectField(item) {
        this.$emit('handleSelectField', item, this.listIndex)
      }
    },
    watch: {
      'value'() {
        this.curVal = this.value
      }
    },
    mixins: []
  }
</script>



// WEBPACK FOOTER //
// honrayDropdownInput.vue?1b0a58a8